export default __webpack_public_path__ + "static/features1-e0f0eea8da4307277925dff2ad15a364.png";